'use client';

import React from 'react';

const SkipLink: React.FC = () => {
    return (
        <a data-component-id="src/components/ui/SkipLink.tsx:7:8" data-component-path="src/components/ui/SkipLink.tsx" data-component-line="7" data-component-end-line="12" data-component-file="SkipLink.tsx" data-component-name="a" data-component-content="%7B%22elementName%22%3A%22a%22%2C%22href%22%3A%22%23main-content%22%2C%22className%22%3A%22skip-link%20font-medium%20rounded-br-lg%22%2C%22textContent%22%3A%22Skip%20to%20main%20content%22%7D"
            href="#main-content"
            className="skip-link font-medium rounded-br-lg"
        >
            Skip to main content
        </a>
    );
};

export default SkipLink;
